import {handleFileSend, handleSend} from '../handleSend'

export const CardApi = {
  // 查询卡信息列表
  queryCardInfoList (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '32', '1001', String(type), 'message')
  },
  // 修改卡信息(0-启用、1-挂失、2-解挂、5-补/换卡、6-卡回收)
  handleCardInfo (data, type = 0) {
    return handleSend(data, '32', '1002', String(type))
  },
  // 批量导入卡信息(存入临时表)
  batchCreateCardInfo (data, fileType = '0') {
    let fd = new FormData() // FormData 对象
    fd.append('file', data) // 文件对象
    fd.append('fileType', fileType)
    fd.append('content', '0')
    fd.append('AppCode', '32')
    fd.append('BizCode', '1004')
    return handleFileSend('/uploadFiles', '32', '1004', fd, 'Alert')
  },
  // 批量导入卡信息查询(临时表)
  batchQueryCardInfo (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '31', '0012', '0', 'message')
  },
  // 批量导入卡信息确认
  batchConfirmCardInfo (data) {
    return handleSend(data, '32', '1005')
  },
  // 查询历史卡记录
  queryCardHistoryRecord (data) {
    return handleSend(data, '32', '1003', '0', 'message')
  },
  // 查询制卡任务列表
  queryCardTaskList (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '32', '2002', '0', 'message')
  },
  // 新增制卡任务
  addNewCardTask (data) {
    data.quantity = String(data.quantity)
    return handleSend(data, '32', '2001')
  },
  // 查询制卡任务流水
  queryCardTaskFlow (data) {
    return handleSend(data, '32', '2003', '0', 'message')
  },
  // 制卡任务处理（0-审批、1-任务回滚、2-任务终止、3-任务删除）
  handleCardTask (data, type) {
    return handleSend(data, '32', '2004', String(type))
  },
  // 预制卡开卡
  generateCard (data) {
    return handleSend(data, '32', '2005')
  },
  // 导入制卡任务文件(存入临时表)
  uploadCardTaskFile (data, id, fileType = '0') {
    let fd = new FormData() // FormData 对象
    fd.append('file', data) // 文件对象
    fd.append('fileType', fileType)
    fd.append('content', id)
    fd.append('AppCode', '32')
    fd.append('BizCode', '2006')
    return handleFileSend('/uploadFiles', '32', '2006', fd, 'Alert')
  },
  // 导出制卡任务数据文件(拿到返回的fileLocation)
  exportCardTaskFile (data) {
    return handleSend(data, '32', '2007')
  },
  // 批量导入卡信息确认
  confirmCardTaskFile (data) {
    return handleSend(data, '32', '2008')
  },
  // 查询持卡人资料(0-查询/1-导出)
  queryCardOwnerList (data, type = '0') {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '32', '2009', String(type))
  },
  // 卡激活
  cardActivation (data) {
    return handleSend(data, '32', '1007')
  }
}



// WEBPACK FOOTER //
// ./src/request/ApplyBasic/card_api.js